import script from "./SensitiveWordManage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensitiveWordManage.vue?vue&type=script&setup=true&lang=ts"

import "./SensitiveWordManage.vue?vue&type=style&index=0&id=25438bc4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25438bc4"]])

export default __exports__